import store from "../../../../store";
import { has } from "../../../../utils/menu-context";
import { commonComponentProp, commonInputPropField } from "../../inform/request/request.condition";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (record.createBy === store.state.resource.auth.info.user?.username
                // || (record.createBy === "anonymousUser" && record.refStorageLocationTemp?.refUser?.username === store.state.resource.auth.info.user?.username)
                || (record.refStorageLocationTemp?.refUser?.username === store.state.resource.auth.info.user?.username)
            ) {
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canArchive: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canArchive" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canDelete: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canDelete" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canWaitReceive: ({ record }) => {
            let result = false;
            if (
                (record.createBy === store.state.resource.auth.info.user?.username ||
                    (record.createBy === "anonymousUser" &&
                        record.refStorageLocationTemp?.refUser?.username === store.state.resource.auth.info.user?.username)) &&
                !record.isOfficerCreate
            ) {
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canWaitApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (record.isOfficerCreate) {
                if (["draft", "reEditOfficer", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            const userInfo = store.state.resource.auth.info?.user;
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    if (record.refToApproveBy?.username === userInfo.username) {
                        result = true || result;
                    }
                }
            }
            return result;
        },
        canReStatus: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forRequest" })) {
                if (["waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            /*
            if (record.createBy === store.state.resource.auth.info.user?.username && record.isOfficerCreate) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            */
            return result;
        },
        canReport: ({ record }) => {
            return !["draft"].includes(record.refStatus?.key);
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return [
                    "refDepartment.nameEn",
                    "lastStatus.waitReceive.0.statusDatetime",
                    "lastStatus.draft.0.statusDatetime",
                    "lastStatus.waitApprove.0.statusDatetime",
                    "refStorageLocationTemp.refUserCompany.companyNameEn",
                    "refStorageLocationTemp.refUser.fullNameEn",
                    "refStorageLocationTemp.refUserCompany.addresses.0.addrTh",
                    "refStorageLocationTemp.refUser.addresses.0.addrTh",
                    "refStorageLocationTemp.addresses.0.refAddressType"
                ].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return ["refStorageLocationTemp.refUserCompany.idCard"].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return ["refStorageLocationTemp.refUser.idCard"].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return ["refRequestType"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ field }) => {
                return ["refDocGenType", "requestCode"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.isOfficerCreate;
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refStorageLocationTemp.approveCode"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.isOfficerCreate;
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["2", "3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refStorageLocationTemp.refUserCompany", "refDepartment"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["2", "3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refStorageLocationTemp.refUser"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refStorageLocation"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["2", "3", "4"].includes(modelRef.refRequestType?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forRequestRemark.0.remark"].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                if (modelRef.isOfficerCreate) {
                    return { ...common, disabled: true };
                }
                console.log("common", common)
                return common;
            }
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forReceiveRemark.0.remark"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    undefined,
                    "draft",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ field }) => {
                return ["refStorageLocationTemp.productionArea", "refStorageLocationTemp.horsepower", "refStorageLocationTemp.worker"].includes(
                    field?.key
                );
            },
            visibleField: ({ modelRef }) => {
                return !modelRef.refStorageLocationTemp.isLocation;
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return (
                    [
                        "refStorageLocationTemp.name",
                        "refStorageLocationTemp.idTax",
                        "refStorageLocationTemp.email",
                        "refStorageLocationTemp.addresses.0.noTh",
                        "refStorageLocationTemp.addresses.0.roomTh",
                        "refStorageLocationTemp.addresses.0.buildingTh",
                        "refStorageLocationTemp.addresses.0.floorTh",
                        "refStorageLocationTemp.addresses.0.villageTh",
                        "refStorageLocationTemp.addresses.0.mooTh",
                        "refStorageLocationTemp.addresses.0.soiTh",
                        "refStorageLocationTemp.addresses.0.roadTh",
                        "refStorageLocationTemp.addresses.0.noEn",
                        "refStorageLocationTemp.addresses.0.roomEn",
                        "refStorageLocationTemp.addresses.0.buildingEn",
                        "refStorageLocationTemp.addresses.0.floorEn",
                        "refStorageLocationTemp.addresses.0.villageEn",
                        "refStorageLocationTemp.addresses.0.mooEn",
                        "refStorageLocationTemp.addresses.0.soiEn",
                        "refStorageLocationTemp.addresses.0.roadEn",
                        "refStorageLocationTemp.addresses.0.refProvince",
                        "refStorageLocationTemp.addresses.0.refAmphur",
                        "refStorageLocationTemp.addresses.0.refTambon",
                        "refStorageLocationTemp.addresses.0.postCode",
                        "refStorageLocationTemp.addresses.0.tel",
                        "refStorageLocationTemp.addresses.0.fax",
                        "refStorageLocationTemp.addresses.0.latitude",
                        "refStorageLocationTemp.addresses.0.longitude",
                        "refStorageLocationTemp.refOwnershipType",
                        "refStorageLocationTemp.isSuitablePosition",
                        "refStorageLocationTemp.isRoyalPalace",
                        "refStorageLocationTemp.isHome",
                        "refStorageLocationTemp.isShoppingArea",
                        "refStorageLocationTemp.isPublicPlace",
                        "refStorageLocationTemp.isIndustrialArea",
                        "refStorageLocationTemp.isSafety",
                        "refStorageLocationTemp.isWaste",
                        "refStorageLocationTemp.isChemical",
                        "refStorageLocationTemp.productTypes"
                    ].includes(field?.key) ||
                    (field?.key?.startsWith("refStorageLocationTemp.experts") &&
                        (field?.key?.endsWith("firstName") ||
                            field?.key?.endsWith("lastName") ||
                            field?.key?.endsWith("idCard") ||
                            field?.key?.endsWith("tel") ||
                            field?.key?.endsWith("email")))
                );
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refStorageLocationTemp.types", "refStorageLocationTemp.productTypes"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return (
                    field?.key?.startsWith("refStorageLocationTemp.subs") &&
                    (field?.key?.endsWith("refType") ||
                        field?.key?.endsWith("buildingName") ||
                        field?.key?.endsWith("totalWidth") ||
                        field?.key?.endsWith("totalLong") ||
                        field?.key?.endsWith("totalHigh") ||
                        field?.key?.endsWith("totalArea") ||
                        field?.key?.endsWith("totalCapacity") ||
                        field?.key?.endsWith("useWidth") ||
                        field?.key?.endsWith("useLong") ||
                        field?.key?.endsWith("useHigh") ||
                        field?.key?.endsWith("useArea") ||
                        field?.key?.endsWith("useCapacity") ||
                        field?.key?.endsWith("useKg"))
                );
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return (
                    field?.key?.startsWith("refStorageLocationTemp.attachments") &&
                    (field?.key?.endsWith("documentName") ||
                        field?.key?.endsWith("attribute.documentNo") ||
                        field?.key?.endsWith("attribute.documentDate") ||
                        field?.key?.endsWith("attribute.documentExpiredDate") ||
                        field?.key?.endsWith("size"))
                );
            },
            inputPropField: ({ modelRef, initialModel, record }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    if (["3", "4"].includes(modelRef.refRequestType?.key)) {
                        if (record?.attribute?.isDisabledDocumentName) {
                            common.disabled = true;
                        }
                    }
                }
                return common;
            }
        },
        {
            check: ({ componentKey }) => {
                return ["StorageLocationExpertList", "StorageLocationSubList"].includes(componentKey);
            },
            inputPropField: commonComponentProp({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ componentKey }) => {
                return ["AttachmentInlineList"].includes(componentKey);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly } = props;
                let canCreate = false;
                let canDelete = false;
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(initialModel.refStatus?.key)) {
                    canCreate = !viewOnly || canCreate;
                    canDelete = !viewOnly || canDelete;
                }
                return { canCreate, canDelete };
            }
        }
    ];
};
